/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getUploadBatchData(context, params) {
    return axios.get('/api/v3/ai_system/user_upload_review/batches', { params })
  },
  getUploadBatches(context, batchId) {
    return axios.get('/api/v3/ai_system/user_upload_review/batches', { params: batchId ? { batch_id: batchId } : {} })
  },
  controlUploadBatch(context, payload) {
    return axios.post('/api/v3/ai_system/user_upload_review/batches', payload)
  },
  getSchoolExamDashboard(context, payload) {
    return axios.get('/api/v2/common/user_upload_file/dashboard', { params: payload })
  },
  /// payload: {school_type: [], grade_id: [], subject_type_id: [], semester: [], state: []}
  getTestPaperList({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/common/user_upload_file_list', { params: {
        school_type: payload.school_type, grade_id: payload.grade_id,
        subject_type_id: payload.subject_type_id, semester: payload.semester,
        state: payload.state, year: payload.year, include_workflow: true,
        user_id: payload.user_id || '', page_size: payload.page_size,
        offset: payload.offset, school_name: payload.school_name,
        processing_tab: payload.processing_tab, workflow_tab: payload.workflow_tab,
        processing_route: payload.processing_route, generation_filter: payload.generation_filter,
        review_filter: payload.review_filter, sort_by: payload.sort_by, sort_order: payload.sort_order,
      } }).then((response) => {
        if (response.data.result == 'success') {
          // commit("SET_ACTIVE_EXAM", response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getTestPage({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user_upload_file?id=" + payload).then((response) => {
        resolve(response)
      });
    })
  },
  // {
  //    "id": 10,
  //    "state": 2,
  //    "comment": "적절하지 않는 시험입니다"
  // }
  setStateTestPaper(context, payload) { 
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/common/user_upload_file', payload).then((response)=> {
        if(response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error)=> {
        reject(error)
      })
    })
  },
  // {id: 10, file_name: 'g_che1_hsj_ANP2A368.pdf', type: 2}
  getTestPageFileSize({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/common/file_size?id=${payload.id}&file_name=${payload.file_name}&type=${payload.type}`).then((response) => {
        resolve({
          'response': response,
          'file_name': payload.file_name,
        })
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // pdf 파일 다운로드 , payload: {'id': 550, 'type': 2, 'file_name': '24년 한국사 답안지.pdf'}
  downPdf({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/common/user_upload_file/download', payload, { responseType: 'blob' }).then((response) => {
        console.log(response);

        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', payload.file_name);
        document.body.appendChild(link);
        link.click();

        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  changeSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/common/user_upload_file/subject_type', payload).then((response)=> {
          resolve(response)
      }).catch(reject);
    })
  },

  // D(0),C(1),B(2),A(3),S(4)
  changeRank(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/common/user_upload_file/rank', payload).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  // AI 검수: 분석과 결과 반영을 분리하고 저장된 결과를 복원한다.
  // payload: {id: 123, apply_side_effect: true}
  runIssue1Filter(context, payload) {
    return new Promise((resolve, reject) => {
      const frm = new FormData()
      frm.append('user_upload_file_id', payload.id)
      frm.append('apply_side_effect', 'false')
      frm.append('action', payload.action || 'analyze')
      if (payload.point != null) frm.append('point', String(payload.point))
      if (payload.reason != null) frm.append('reason', payload.reason)
      if (payload.issueToken != null) frm.append('issue_token', payload.issueToken)
      if (payload.rejectionToken != null) frm.append('rejection_token', payload.rejectionToken)
      if (typeof payload.remoteRejected === 'boolean') frm.append('remote_rejected', String(payload.remoteRejected))
      if (typeof payload.remoteApproved === 'boolean') frm.append('remote_approved', String(payload.remoteApproved))

      axios.post('/api/v3/ai_system/user_upload_review/issue1', frm, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  previewRejectedReopen(context, id) {
    return axios.get('/api/v3/ai_system/user_upload_review/reopen', { params: { user_upload_file_id: id } })
  },
  reopenRejectedUpload(context, id) {
    const form = new FormData()
    form.append('user_upload_file_id', id)
    return axios.post('/api/v3/ai_system/user_upload_review/reopen', form)
  },

  previewMissingExamRecovery(context, id) {
    return axios.get('/api/v3/ai_system/user_upload_review/recover_exam', { params: { user_upload_file_id: id } })
  },
  recoverMissingExam(context, id) {
    const form = new FormData()
    form.append('user_upload_file_id', id)
    return axios.post('/api/v3/ai_system/user_upload_review/recover_exam', form)
  },

  downloadTextificationLogs(context, id) {
    return axios.get('/api/v3/ai_system/school_exam_textification/logs', {
      params: { user_upload_file_id: id }, responseType: 'blob',
    })
  },

  previewExamRebuild(context, id) {
    return axios.get('/api/v3/ai_system/user_upload_review/rebuild', { params: { user_upload_file_id: id } })
  },
  rebuildExam(context, payload) {
    const form = new FormData()
    form.append('user_upload_file_id', payload.id)
    form.append('school_subject_id', payload.schoolSubjectId)
    return axios.post('/api/v3/ai_system/user_upload_review/rebuild', form)
  },

  getIssue1Review(context, id) {
    return axios.get('/api/v3/ai_system/user_upload_review/issue1', { params: { user_upload_file_id: id } })
  },

  // 사용자 업로드 잠금과 저장된 시험 연결을 검증한 후 텍스트화
  // payload: {examSubjectId: 456}
  runQuestionIngestor(context, payload) {
    return new Promise((resolve, reject) => {
      const frm = new FormData()
      frm.append('user_upload_file_id', payload.id)
      frm.append('action', 'ingest')

      axios.post('/api/v3/ai_system/user_upload_review/issue1', frm, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}
